import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MODAL, MOBILE_MODAL } from 'src/app/shared/animations/modal-animation';

@Component({
  selector: 'app-modal-custom',
  templateUrl: './modal-custom.component.html',
  styleUrls: ['./modal-custom.component.scss'],
  animations: [MODAL, MOBILE_MODAL],
})
export class ModalCustomComponent implements OnInit {
  @Input() titleText: string;

  @Input() saveButtonText: string;

  @Input() cancelButtonText: string;

  @Input() cancelButtonShown: boolean = false;

  @Input() infoText: string;

  @Input() fullscreen: boolean = false;

  @Output() onModalSave = new EventEmitter();

  @Output() onModalClose = new EventEmitter();

  public modalShown: boolean = false;

  public isModalMobile: boolean = false;

  constructor() {}

  ngOnInit(): void {
    this.resize();
  }

  public openModal(event: any) {
    event.stopPropagation();
    this.modalShown = true;
  }

  public saveModalContent() {
    this.onModalSave.emit();
  }

  public closeModal() {
    this.onModalClose.emit();
    this.modalShown = false;
  }

  @HostListener('window:resize') resize() {
    if (window.innerWidth < 577) {
      this.isModalMobile = true;
    } else this.isModalMobile = false;
  }
}
